import { useEffect } from 'react';
import { io } from 'socket.io-client';
import { useQueryClient } from '@tanstack/react-query';
import { SOCKET_EVENTS, type WorkSessionSummary } from '@stoplord/shared';
import { useAuth } from '@/store/auth';
import { toast } from '@/store/ui';

export function useRealtime() {
  const token = useAuth((s) => s.accessToken);
  const qc = useQueryClient();
  useEffect(() => {
    if (!token) return;
    const socket = io({ path: (import.meta.env.VITE_SOCKET_PATH as string | undefined) ?? '/socket.io', transports: ['websocket'], auth: { token } });
    socket.on(SOCKET_EVENTS.NOTIFICATION, (n: { title: string; body?: string }) => {
      void qc.invalidateQueries({ queryKey: ['notifications'] });
      toast.info(n.title, n.body);
    });
    socket.on(SOCKET_EVENTS.SESSION_REVOKED, ({ reason }: { reason: string }) => {
      useAuth.getState().clear(reason === 'idle_timeout' || reason === 'heartbeat_lost' ? 'idle' : 'revoked');
    });
    const onWs = (ws: WorkSessionSummary) => useAuth.getState().setWorkSession(ws);
    socket.on(SOCKET_EVENTS.WORK_SESSION_UPDATED, onWs);
    socket.on(SOCKET_EVENTS.WORK_SESSION_ENDED, onWs);
    return () => {
      socket.disconnect();
    };
  }, [token, qc]);
}
